<template>
    <div class="borderelement text-secondary-text text-sm md:text-xl md:-mr-12 my-3 bg-transparent-white p-4  md:pt-8 md:pr-12 md:-mt-4 md:text-right leading-normal ">
        <the-text-view :value="articleItem.news_image__text" />
    </div>
</template>

<script>

    import TheTextView from './TheTextView'

    export default {
        name: 'TheCaption',
        components: {
            TheTextView
        },
        data() {
            return {
            }
        },

        props: {
            articleItem: {
                type: Object,
                default: () => {}
            }
        },
        created: function() {

        }
    }
</script>

<style lang="scss">
    .borderelement{
        position: relative;
        &:before,
        &:after{
             content: '';
             width: 8px;
             height: 40px;
             position: absolute;
         }
        &:before{
             background-color: #c93c26;
             left: 0;
             top: 0;
         }
        &:after{
             background-color: #47ab4c;
             right: 0px;
             bottom: 0;
         }
    }
</style>